import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {
  AppBar,
  Box,
  Button,
  Divider,
  Toolbar,
  Hidden,
  Typography,
  makeStyles
} from '@material-ui/core';
import getFlagValue from 'src/utils/configUtil';
import Logo from 'src/components/Logo';

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default
  },
  toolbar: {
    height: 64
  },
  logo: {
    marginRight: theme.spacing(2)
  },
  link: {
    fontWeight: theme.typography.fontWeightMedium,
    '& + &': {
      marginLeft: theme.spacing(2)
    }
  },
  divider: {
    width: 1,
    height: 32,
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2)
  }
}));

function TopBar({ className, ...rest }) {
  const classes = useStyles();
  const isMaintenanceEnabled = getFlagValue(process.env.REACT_APP_MAINTENANCE_ENABLED ?? '');
  const isNewLandingEnabled = getFlagValue(process.env.REACT_APP_NEW_LANDING_ENABLED ?? '');


  return (
    <AppBar
      className={clsx(classes.root, className)}
      color="default"
      {...rest}
    >
      <Toolbar className={classes.toolbar}>
        <RouterLink to="/">
          <Logo className={classes.logo} override={'/static/TireRackLogo.png'}/>
        </RouterLink>
        <Hidden mdDown>
          <Typography
            variant="caption"
            color="textSecondary"
          >
            Claims
          </Typography>
        </Hidden>
        <Box flexGrow={1} />
        {!(isMaintenanceEnabled || isNewLandingEnabled) && (
          <>
            <Divider className={classes.divider} />
            <Button
              color="secondary"
              component="a"
              href="/login"
              variant="contained"
              size="small"
            >
              Log In
            </Button>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
}

TopBar.propTypes = {
  className: PropTypes.string
};

export default TopBar;
